import EA from '../helpers/init';

export default EA.Methods.headerLoadAnim = ($this) => {
    const logo = $this.querySelector('.site-logo');
    const navLinks = $this.querySelectorAll('.header-inner > .nav-links > .nav-link');

    const animElements = [logo, ...navLinks];

    setTimeout(() => {
        animElements.forEach((el, index) => {
            setTimeout(() => {
                el.classList.add('show');
            }, index * 100);
        });
    }, 600);
};
